import { Component, Inject, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AppComponent } from "../app/app.component";
import { Location } from "@angular/common";


@Component({
    selector: 'home',
    template: require('./home.component.html'),
    styles: [require('./home.component.css')]
})
export class HomeComponent implements OnInit{
    ngOnInit(): void {
        
    }
    public location: AssiLocation;
    public report: CollisionReport;
    public autocom: Lookup[];
    constructor(private appcomponent: AppComponent
                , private router: Router) {
      //  translate.setDefaultLang('en');
        this.location = <AssiLocation>{};
        this.report = appcomponent.getReport();
        this.report.Location = <AssiLocation>{};
        if (this.report.Language == null) {
            this.report.Language = "en";
        }
        //Autocomplete Mock
        this.autocom = [];
        console.log(this.autocom);
        this.populateLocation();

        document.body.scrollTop = 0;

    }
    useLanguage(language: string) {
        this.appcomponent.translate.use(language);
    }
    populateLocation(): void {
        this.location = this.appcomponent.getLocation();
        this.report.Location = this.location;

    }
    onLanguageSelectionChange(lang: string): void {
        this.report.Language = lang;
        this.useLanguage(lang);
       
    }
    onSubmit(): void {

        if (this.report.Language == null) {
            this.onLanguageSelectionChange('en');
        }
        this.ValidateAndPost();
        this.router.navigate(["checklist"]);
    }

    private ValidateAndPost() {
        this.report.IsWelcomePageValid = true;
        this.appcomponent.setReport(this.report);
    }

    public findChoices(searchText: string) {
       
        return ['John', 'Jane', 'Jonny'].filter(item =>
            item.toLowerCase().includes(searchText.toLowerCase())
        );
    }

    getChoiceLabel(choice: string) {
        return choice;
    }
}
